import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { scrollTo } from '@modules/_misc';
import { HOME_PAGE_FAQS } from '@modules/react_content';
import _svg from '@modules/svg';
import { userActions } from '@reducers/user';
import Home from '@views/Public/shared-content/Home';
import withRouter from '@wrappers/withRouter';

const { VITE_ENV } = import.meta.env;

const Index = props => {
	let { location, navigate } = props,
		dispatch = useDispatch(),
		logout = () => dispatch(userActions.logout()),
		unsetDirectAdmit = () => dispatch(userActions.setDirectAdmit({})),
		{ logging_out } = location.state || {};

	useEffect(() => {
		if (logging_out) logout();
		scrollTo();
	}, []);

	return (
		<Home
			mainContent={
				<>
					<h2>
						Universities of Wisconsin Admission Pathway Portal
						{VITE_ENV !== 'production' && (
							<>
								<br />({`${VITE_ENV === 'practice' ? 'Practice' : 'Development'} Application`})
							</>
						)}
					</h2>

					<h1>
						all paths <span>start here</span>
					</h1>

					<div>
						<input
							type='button'
							onClick={() => {
								unsetDirectAdmit();
								navigate('/create-account');
							}}
							className='btn-general primary'
							value='Create an account'
						/>
						<input
							type='button'
							onClick={() => {
								unsetDirectAdmit();
								navigate('/sign-in');
							}}
							className='btn-general'
							value='sign in'
						/>
					</div>

					<p>
						Explore the{' '}
						<a className='pfa-home-link' onClick={() => navigate('/how-to-apply')}>
							paths for admission
						</a>
						.
					</p>
				</>
			}
			faqs={HOME_PAGE_FAQS.general}
		/>
	);
};

export default withRouter(Index);
